import { continueSession } from '../actions/session';
import history from '../wiring/history';

export default (store) => {
    history.listen(() => {
        store.dispatch(continueSession());
    });
};
